import { Button, Card, Layout, Page, Text, Banner } from '@shopify/polaris'
import { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'

import { useAdminAuth } from '../providers/AdminAuthProvider'
import { useFirebase } from '../providers/FirebaseProvider'

export default function AdminLoginPage() {
  const { user, signInWithGoogle } = useFirebase()
  const {
    error: adminError,
    loading: adminLoading,
    adminUser,
    clearError,
  } = useAdminAuth()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const isAdminVerifying = Boolean(user && adminLoading)

  // Show admin auth errors on the login page
  useEffect(() => {
    if (adminError) {
      setError(adminError)
      clearError() // Clear the error from admin auth context
    }
  }, [adminError, clearError])

  const handleSignIn = async () => {
    setLoading(true)
    setError(null)
    try {
      await signInWithGoogle()
    } catch (error) {
      console.error('Sign in error:', error)
      setError(
        error instanceof Error
          ? error.message
          : 'Failed to sign in. Please try again.'
      )
    } finally {
      setLoading(false)
    }
  }

  // Only navigate away if user exists AND admin verification is complete AND successful
  if (user && !adminLoading && adminUser) {
    return <Navigate to="/" replace />
  }

  return (
    <Page>
      <Layout>
        <Layout.Section>
          <div
            style={{ maxWidth: '400px', margin: '0 auto', marginTop: '64px' }}
          >
            {error && (
              <div style={{ marginBottom: '16px' }}>
                <Banner tone="critical">{error}</Banner>
              </div>
            )}
            <Card>
              <div style={{ textAlign: 'center', padding: '32px' }}>
                <Text as="h1" variant="headingLg">
                  Go Wishlist Admin Dashboard
                </Text>
                <div style={{ marginTop: '16px', marginBottom: '32px' }}>
                  <Text as="p">
                    {isAdminVerifying
                      ? 'Verifying admin access...'
                      : 'Sign in with your Google account to access the admin dashboard.'}
                  </Text>
                </div>
                <Button
                  variant="primary"
                  size="large"
                  onClick={handleSignIn}
                  loading={loading || isAdminVerifying}
                  disabled={loading || isAdminVerifying}
                >
                  {loading
                    ? 'Signing in...'
                    : isAdminVerifying
                      ? 'Verifying access...'
                      : 'Sign in with Google'}
                </Button>
              </div>
            </Card>
          </div>
        </Layout.Section>
      </Layout>
    </Page>
  )
}
